export enum AverageSpeedFilter {
  VEHICLES = "Vehicles",
  DRIVERS = "Drivers"
}
